import React from "react";
import { CheckboxField, checkBoxProps } from "./CheckboxField";

export const SwitchCheckboxField = (props: checkBoxProps) => (
  <CheckboxField {...props} customLabelClass="custom-switch" />
);
